type PaginationProps = {
  current: number;
  total: number;
  onChange: (page: number) => void;
};

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
              page === current
                ? "bg-primary-500 text-background-50 font-medium"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-foreground-400">
            …
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}